import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import stringHelper from '../../../../Helpers/stringHelper';
import ErrorMessage from '../../../ErrorMessage';
import UserService from '../../../../Services/userService';

export default class UserSelectWithGuid extends React.Component
{
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => { },
    active: false,
  };

  constructor (props)
  {
    // console.log('Constructing UserSelectWithGuid with props: ', props);
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount ()
  {
    this.populateListData();
  }

  populateListData ()
  {
    UserService.GetUserList()
      .then((result) =>
      {
        result.sort((a, b) =>
          `${a.lastname} ${a.firstName}`.toLocaleLowerCase() > `${b.lastname} ${b.firstName}`.toLocaleLowerCase()
            ? 1
            : -1
        );
        const optValues = [ { label: 'Choose one...', value: '', disabled: false } ];
        result.forEach((user) =>
        {
          if (!this.props.active || user.isActive)
          {
            optValues.push({
              label: `${user.firstName} ${user.lastName}${stringHelper.toBracket(user.userName)}`,
              value: user.guidId,
              disabled: false,
            });
          }
        });
        this.setState({ selectValues: optValues });
      })
      .catch((ex) =>
      {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('USWG58', ex);
      });
  }

  render ()
  {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
